import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getLatestTaskList } from "../Firebase/getLatestTaskListAction";
import * as idb from '../../../functions/databaseService/indexedDB';
import { isNullOrUndefined } from "../../../utils/todo-utils";
import signOut from "../../../functions/userIdentity/signOut";
import * as Sentry from "@sentry/capacitor";

// Action Types
export const FIREBASE_EDIT_TASK_SUCCESS = "FIREBASE_EDIT_TASK_SUCCESS";
export const FIREBASE_EDIT_TASK_ERROR = "FIREBASE_EDIT_TASK_ERROR";

// Thunk Action Creator
export const editTaskInFirebase = createAsyncThunk(
    "api/Task/editTask",
    async (json, { dispatch }) => {
        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.put(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/editTask/${json.id}`,
                    {
                        id: json.id,
                        Title: (isNullOrUndefined(json.Title)) ? '' : json.Title,
                        IsCompleted: (isNullOrUndefined(json.IsCompleted)) ? false.toString() : json.IsCompleted,
                        HasDescription: (isNullOrUndefined(json.Description)) ? false.toString() : true.toString(),
                        Description: (isNullOrUndefined(json.Description)) ? '' : json.Description,
                        HasDueDate: (isNullOrUndefined(json.HasDueDate)) ? false.toString() : json.HasDueDate,
                        DueDate: (isNullOrUndefined(json.DueDate)) ? '' : json.DueDate,
                        VisualSize: (isNullOrUndefined(json.VisualSize)) ? '' : json.VisualSize.toString(),
                        HasSnoozedUntil: (isNullOrUndefined(json.HasSnoozedUntil)) ? false.toString() : json.HasSnoozedUntil,
                        SnoozedUntil: (isNullOrUndefined(json.SnoozedUntil)) ? '' : json.SnoozedUntil,
                        HasNotification: (isNullOrUndefined(json.HasNotification)) ? false.toString() : json.HasNotification,
                        NotificationDate: (isNullOrUndefined(json.NotificationDate)) ? '' : json.NotificationDate,
                        HasTaskSize: (isNullOrUndefined(json.HasTaskSize)) ? false.toString() : json.HasTaskSize,
                        TaskSize: (isNullOrUndefined(json.TaskSize)) ? '' : json.TaskSize
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )

                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }
                }
                else {
                    throw new Error("Error editing task in firebase");
                }
                //get data from indexed DB
                //const taskListData = await idb.getTasks();

                //Dispatch Indexed DB instead of Axios result
                dispatch({
                    type: FIREBASE_EDIT_TASK_SUCCESS,
                    payload: response.data
                });

            } else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: FIREBASE_EDIT_TASK_SUCCESS,
                        payload: taskListData
                    });

                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }
        }catch(error) {
            // Only capture client-side/network errors; server 500+ errors are already captured by TaskController
            if (!error.response || error.response.status < 500) {
                Sentry.captureException(error, {
                    tags: {
                        error_type: 'task_edit_failure',
                        operation: 'editTaskInFirebase',
                        is_online: navigator.onLine,
                    },
                    level: 'error',
                    extra: {
                        task_id: json?.id,
                        status_code: error.response?.status,
                    }
                });
            }
            dispatch({ type: FIREBASE_EDIT_TASK_ERROR, payload: error });
            await signOut();
        }
    }
);
